import { type JsonDataItem } from '@g2u/ui-kit';
import { type FormInstance } from 'antd';

function isError(error: JsonDataItem | Error): error is Error {
  return error instanceof Error || 'message' in error;
}

export const normaliseData = (data: JsonDataItem) => {
  return Object.entries(data)
    .filter(([_, value]) => !!value)
    .map(([ID, value]) => ({
      ID,
      value,
    }));
};

export const parseError = (error: JsonDataItem | Error): string => {
  if (isError(error)) {
    return error.message;
  }
  if (error.errors && Array.isArray(error.errors) && error.errors.length > 0) {
    return error.errors.join(', ');
  }
  if (error.message) {
    return error.message;
  }
  return 'An unknown error occurred';
};

export const validateFormSilently = async (
  form: FormInstance,
  setState: (status: boolean) => void
) => {
  form
    .validateFields({ validateOnly: true })
    .then(() => {
      setState(true);
    })
    .catch((errorInfo) => {
      errorInfo.errorFields.length ? setState(false) : setState(true);
    });
};
